<template>
  <div class="content">
    <div class="column">
      <!-- 複数もぎりの場合、使用フローにのったままならstoreに値が保管されているので使用枚数を表示 -->
      <FaceUsedNumber
        v-if="
          book.master_limits[0].limit_master_sheet_ids.length > 1 &&
          storeCountOfMultiSheets
        "
        :count="storeCountOfMultiSheets"
      />

      <!-- division毎の購入枚数の表示(複数もぎりの場合は非表示) -->
      <BgFaceDivisionCountDisp
        v-else-if="
          book.master_limits[0].limit_master_sheet_ids.length < 2 &&
          divisionsInfo[0].label
        "
        :divisions="divisionsInfo"
      />
      <!-- division毎の購入枚数の表示 -->
    </div>

    <!-- チェック場所 -->
    <SFaceCheckinDisp :location-name="frame.location.name" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import bookGroupService from "@/services/bookGroup";

export default {
  name: "TheSheetUsedUpper",

  props: {},
  setup() {
    const store = useStore();

    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const frame = computed(() => store.getters["ticketing/frame"]);
    const storeCountOfMultiSheets = computed(
      () => store.getters["ticketing/storeCountOfMultiSheets"]
    );

    const divisionsInfo = ref([{ division: null, label: null, count: null }]);

    onMounted(async () => {
      // 表示用のdivisionを生成(複数もぎりの場合は不要)
      if (book.value.master_limits[0].limit_master_sheet_ids.length < 2) {
        divisionsInfo.value = await bookGroupService.divisionArrange(
          bookGroup.value.books
        );
      }
    });

    return {
      book,
      frame,
      storeCountOfMultiSheets,
      divisionsInfo,
    };
  },
};
</script>
